import { fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';
import type { OperationsConfiguration } from '@/types/OperationsConfiguration';
import type { EditedBandItem } from '@/types/GridTypes';

export const createPayload = (editedBands: EditedBandItem[] | undefined, configurationData: OperationsConfiguration) => {
    if (editedBands) {
        const items = editedBands
            .filter((band) => !band.isDefault)
            .map((band) => ({
                unitType: band.unitType,
                unitValue: band.unitValue
            }));
        
        return { globalConfig: { ageBandConfig: { items } } };
    } else {
        const items = configurationData.globalConfig.ageBandConfig.items.map((item) => ({
            unitType: item.unitType,
            unitValue: item.unitValue
        }));
        
        return { globalConfig: { ageBandConfig: { items } } };
    }
};

export const fetchConfiguration = async (baseUrl: string) => {
    return await fetchFromLambda<OperationsConfiguration>(baseUrl);
};

export const updateConfiguration = async (baseUrl: string, payload: object, hasId?: string) => {
    const method = hasId ? 'PUT' : 'POST';
    const url = hasId ? `${baseUrl}/${hasId}` : baseUrl;

    return await fetchFromLambda<OperationsConfiguration>(url, {
        method,
        body: JSON.stringify(payload),
        headers: { 'Content-Type': 'application/json' }
    });
};

export const resetConfiguration = async (baseUrl: string, configId: string) => {
    const url = `${baseUrl}/${configId}`;
    return await fetchFromLambda<OperationsConfiguration>(url, { method: 'DELETE' });
};